import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class LicenceRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param siteId
   */
  list(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.LICENCE_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   */
  activate(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.LICENCE_ACTIVATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   */
  deactivate(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.LICENCE_DEACTIVATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   */
  getToken(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.LICENCE_TOKEN;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   */
  activateAll(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.LICENCE_ACTIVATE_ALL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   */
  extractExcel(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.LICENCE_EXTRACT_EXCEL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network
      .http()
      .put(url, form.toString(), { headers, responseType: 'arraybuffer' });
  }
}
